import Link from "next/link";

interface StoryblokLink {
    id?: string;
    url?: string;
    linktype: "story" | "url" | "email" | "asset";
    fieldtype: "multilink";
    cached_url?: string;
    anchor?: string;
    target?: string;
}

interface NavItem {
    Label?: string;
    Beschreibung?: string;
    Link?: StoryblokLink;
    SubItem?: NavItem[];
}

interface MenuItemWithDropdownProps {
    item: NavItem;
    index: number;
    pathname: string;
    getLinkUrl: (link?: StoryblokLink) => string;
}

export default function MenuItemWithDropdown({ item, index, pathname, getLinkUrl }: MenuItemWithDropdownProps) {
    const href = getLinkUrl(item.Link);
    const target = item.Link?.target;

    const subItems = (item.SubItem || []).filter((subItem) => subItem && subItem.Label && subItem.Link);
    const hasSubItems = subItems.length > 0;
    const isActive = !hasSubItems && pathname === href;

    return (
        <div className="group relative">
            {hasSubItems ? (
                <button
                    type="button"
                    className="nav-link inline-flex items-center gap-1"
                    aria-haspopup="menu"
                    aria-expanded="false"
                >
                    <span>{item.Label}</span>
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                        className="transition-transform duration-200 group-hover:rotate-180"
                    >
                        <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            ) : (
                <Link
                    href={href}
                    target={target}
                    className={`nav-link inline-flex items-center gap-1 ${isActive ? "active-link" : ""}`}
                >
                    <span>{item.Label}</span>
                </Link>
            )}

            {hasSubItems && (
                <div className="pointer-events-none absolute left-1/2 top-full z-40 w-[20vw] -translate-x-1/2 pt-2 opacity-0 transition-opacity duration-200 group-hover:pointer-events-auto group-hover:opacity-100">
                    <div className="rounded-2xl border border-white/15 w-full bg-neutral-950 p-2 shadow-2xl shadow-black/40">
                        <div className="grid grid-cols-1 gap-2">
                            {subItems.map((subItem, subIndex) => {
                                const subHref = getLinkUrl(subItem.Link);
                                const subIsActive = pathname === subHref;

                                return (
                                    <Link
                                        key={`${subItem.Label}-${index}-${subIndex}`}
                                        href={subHref}
                                        target={subItem.Link?.target}
                                        className={`rounded-lg px-3 py-2 text-sm transition ${subIsActive ? "bg-white/15 text-white" : "text-slate-200 hover:bg-white/10 hover:text-white"}`}
                                    >
                                        <span className="block font-medium">
                                            {subItem.Label}
                                        </span>
                                        <span className="text-xs font-medium text-white/50">
                                            {subItem.Beschreibung}
                                        </span>

                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
